import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import social_media from "../assets/images/social_media.jpg";
import { NotificationManager } from "react-notifications";
import Footer from "../components/Footer";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

const Profile = () => {
  const [profile, setProfile] = useState({
    username: "",
    email: "",
    mobile: "",
    role: "",
    gender: "",
  });
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");
  const storedUser = localStorage.getItem("user");

  // Prefill from localStorage
  useEffect(() => {
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      setProfile((prev) => ({ ...prev, ...userData }));
      setLoading(false);
    }
  }, [storedUser]);

  // Fetch fresh profile
  useEffect(() => {
    if (!token) return;
    axios
      .get(`${process.env.REACT_APP_HOST_API_URL}/auth/profile/`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setProfile(res.data);
        localStorage.setItem("user", JSON.stringify(res.data));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching profile:", err);
        setLoading(false);
      });
  }, [token]);

  // Fetch orders + transactions + addresses
  useEffect(() => {
    if (!token) return;
    fetch(`${process.env.REACT_APP_HOST_API_URL}/api/orders/`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(async (res) => {
        if (!res.ok) {
          const text = await res.text();
          throw new Error(text);
        }
        return res.json();
      })
      .then((resData) => {
        if (resData.status === 200 && resData.data && resData.data.length > 0) {
          // Keep each transaction grouped with its orders and addresses
          const groupedData = resData.data.map((item) => ({
            transaction: item.transaction[0], 
            orders: item.orders || [],
            addresses: item.addresses || [],
          }));

          setTransactions(groupedData);
          console.log("Grouped transactions", groupedData);
        }
      })
      .catch((err) => {
        console.error("Error fetching orders:", err);
      });
  }, [token]);

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .put(`${process.env.REACT_APP_HOST_API_URL}/auth/update-user/`, profile, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      })
      .then((res) => {
        NotificationManager.success("Profile updated successfully!");
        setProfile(res.data);
        localStorage.setItem("user", JSON.stringify(res.data));
      })
      .catch((err) => {
        NotificationManager.error("Error updating profile:", err);
      });
  };

  return (
    <div className="main">
      <div className="base d-flex flex-column bg-white" style={{ minHeight: "100%", height: "auto" }}>
        <div className="child-nav">
          <Navbar />
        </div>

        {/* Profile Header */}
        <div className="flex container mt-5">
          <div>
            <img src={social_media} alt="profile" className="img-thumbnail" style={{ width: "10rem" }} />
          </div>
          <div className="mx-4 d-flex align-items-end">
            <div>
              <p className="h4 text-capitalize">{profile.username}</p>
              <p className="font-italic">{profile.email}</p>
              <p className="text-muted">{profile.mobile}</p>
            </div>
          </div>
        </div>

        {/* Nav Tabs */}
        <div className="mx-3">
          <ul className="nav nav-tabs mt-4 container ">
            <li className="nav-item">
              <a className="nav-link active" aria-current="page" style={{ cursor: "pointer" }}>
                Orders
              </a>
            </li>
          </ul>
        </div>

        {/* Transactions List */}
        <div className="container mt-3 d-flex flex-column align-items-start">
          {transactions.length === 0 ? (
            <p>No transactions found.</p>
          ) : (
            transactions.map((txnData, idx) => {
              const txn = txnData.transaction;
              const txnOrders = txnData.orders;
              const txnAddresses = txnData.addresses;

              return (
                <div key={idx} className="card mb-4 shadow-sm w-100 border ">
                  <div className="card-body d-flex justify-content-between align-items-center flex-wrap w-100">
                    {/* Left: Reference Number */}
                    <div>
                      <strong className="text-muted px-2">RF: {txn.reference_number}</strong>
                    </div>

                    {/* Right: Amount, Status, More Info */}
                    <div className="d-flex align-items-center gap-3 flex-grow-1">
                      <div className="d-flex align-items-center gap-3 px-2">
                        <strong className="mb-0 text-muted">${txn.amount}</strong>
                        <p
                          className={`mb-0 text-capitalize ${
                            txn.status === "succeeded" ? "text-success" : "text-warning"
                          }`}
                        >
                          {txn.status}
                        </p>
                      </div>

                      <button
                        className="btn btn-outline-primary btn-sm ms-auto"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapseTxn${idx}`}
                        aria-expanded="false"
                        aria-controls={`collapseTxn${idx}`}
                      >
                        More Info
                      </button>
                    </div>
                  </div>

                  {/* Collapse Section */}
                  <div className="collapse w-100" id={`collapseTxn${idx}`}>
                    <div className="card-body d-flex flex-column flex-sm-row justify-content-between w-100">
                      {/* Orders */}
                      {txnOrders.length > 0 && (
                        <div className="table-responsive">
                          <table className="table table-bordered align-middle">
                            <tbody>
                              {txnOrders.map((order, i) => {
                                let noteData = {};
                                try {
                                  noteData = JSON.parse(order.note);
                                } catch {
                                  noteData = {};
                                }

                                return (
                                  <tr key={i}>
                                    <td style={{ width: "30%", color: "#0564bf", fontWeight: "bold" }}>
                                      {noteData.service || "Service"}
                                    </td>
                                    <td className="text-start">
                                      {Object.entries(noteData).map(([key, value]) => {
                                        if (key === "service") return null;
                                        return (
                                          <div key={key} className="mb-1">
                                            <strong className="text-capitalize">{key}:</strong> {value}
                                          </div>
                                        );
                                      })}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      )}

                      {/* Addresses */}
                      {txnAddresses.length > 0 && (
                        <div className="d-flex flex-column gap-3 text-end">
                          {txnAddresses.map((addr, i) => (
                            <div key={i}>
                              <p className="mb-1">
                                <strong style={{ color: "#0564bf" }}>{addr.name}</strong>
                              </p>
                              <p className="mb-1">
                                {addr.address}{addr.zip_code}
                              </p>
                              <p className="mb-0">📞 {addr.mobile}</p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Profile;
